import { TaxRegion } from "@/Contracts/Users";
import ZForm from "@organisms/ZForm";
import {
	IFormSectionProps,
	EWidgets,
	ICustomFormItemProps,
	IFormProps
} from "@organisms/ZForm/interface";
import React from "react";
import ZTable from "@organisms/ZTable";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import ZCheckbox from "@atoms/ZCheckbox";
import { ITaxCategoryFormProps } from "./interface";
import { defaultProductTypeFormItem } from "@/V2Utils";

const ZTaxCategoryForm: React.FC<ITaxCategoryFormProps> = ({
	isLoading = false,
	taxRegionsList = [],
	form,
	onSubmit,
	handleClose,
	taxCategoryCodesColumns,
	tableLoading = false,
	handleFormChange
}) => {
	const sections: IFormSectionProps[] = [
		{
			isIndentFormItems: false,
			hideDivider: true,
			meta: {
				formItemLayout: [5, 19],
				fields: [
					{
						key: "name",
						label: "Category Name",
						required: true,
						message: "Please enter category name",
						hasFeedback: true,
						widget: EWidgets.INPUT,
						widgetProps: {
							width: "full",
							placeholder: "Please enter category name"
						},
						rules: [
							{
								whitespace: true,
								message: "Please enter category name"
							}
						]
					},
					{
						key: "identifier",
						label: "Tax Code",
						required: true,
						message: "Please enter tax code",
						hasFeedback: true,
						widget: EWidgets.INPUT,
						widgetProps: {
							width: "full",
							placeholder: "Please enter tax code"
						},
						rules: [
							{
								whitespace: true,
								message: "Please enter tax code"
							}
						]
					},
					{
						...defaultProductTypeFormItem
					},
					{
						key: "tax_codes_table",
						render: () => (
							<ZTable<TaxRegion>
								size="small"
								loading={isLoading || tableLoading}
								scroll={{ scrollToFirstRowOnChange: true }}
								bordered={false}
								dataSource={taxRegionsList}
								columns={taxCategoryCodesColumns}
								rowKey="id"
								pagination={false}
							/>
						)
					}
				]
			}
		},
		{
			isFooterSection: true,
			meta: {
				fields: [
					{
						key: "disabled",
						initialValue: true,
						widget: ({ value, onChange }: ICustomFormItemProps) => (
							<div className="inline-flex items-center">
								<ZCheckbox
									checked={value}
									onChange={(e: CheckboxChangeEvent) =>
										onChange(e.target.checked)
									}
									disabled={isLoading}
								>
									Active
								</ZCheckbox>
							</div>
						)
					}
				]
			}
		}
	];

	const formProps: IFormProps = {
		key: "tax_category_drawer",
		form,
		loading: isLoading,
		sections,
		onFinish: onSubmit,
		onCancel: handleClose,
		isStickFooter: true,
		submitButtonText: "Save",
		isCancelAllowed: true,
		isRightFooter: true,
		shouldDisableBeforeTouch: false,
		preserve: false,
		shouldResetFormOnCancel: false,
		onValuesChange: handleFormChange
	};

	return <ZForm {...formProps} className="py-4" />;
};

export default ZTaxCategoryForm;
